export default __webpack_public_path__ + "static/media/herogif.f9a9761c.gif";